export function scrollToTop(behavior = "auto") {
    window.scrollTo({ top: 0, left: 0, behavior });
}
